import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { faSpinner, faArrowLeft, faFileInvoiceDollar } from '@fortawesome/pro-regular-svg-icons';
import { HorseShowService } from '../../../providers/horse-show.service';
import { OrganizerService } from '../../../providers/organizer.service';
import { VenueService } from '../../../providers/venue.service';
import { HorseShowEntryService } from '../../../providers/horse-show-entry.service';
import { Organizer } from '../../../models/organizer';
import { Horse_show } from '../../../models/horse_show';
import { Horse_show_entry } from '../../../models/horse_show_entry';
import { Venue } from '../../../models/venue';
import { SmsAbstractAppPage } from '../../sms-abstract-app-page';

@Component({
  standalone: false,
  selector: 'app-view-account-statement',
  templateUrl: './view-account-statement.component.html',
styleUrls:  ['./view-account-statement.component.css']
})
export class ViewAccountStatementComponent extends SmsAbstractAppPage implements OnInit {

  faSpinner = faSpinner;
  faArrowLeft = faArrowLeft;
  faFileInvoiceDollar = faFileInvoiceDollar;

  organizer: Organizer = new Organizer({});
  horse_show: Horse_show = new Horse_show({});
  venue: Venue = new Venue({});
  loading: boolean = false;
  entry: Horse_show_entry = this.getBlankHorseShowEntry();

  /**
   * The office's statement for this entry hasn't reached us yet. That is not the
   * same thing as an entry with nothing on it, so the template says so in words
   * rather than rendering a statement of zeros.
   */
  statement_unavailable: boolean = false;

  constructor(private horseShowEntryService: HorseShowEntryService,
    private horseShowService: HorseShowService,
    private organizerService: OrganizerService,
    private venueService: VenueService,
    private route: ActivatedRoute) {
    super();
  }

  ngOnInit(): void {

    this.route.params.subscribe(params => {

      const entry_id = params['entry_id'];

      if(entry_id == undefined || entry_id == ''){
        this.handleError('This statement was opened without an entry, so there is nothing to show. Go back to your statement list and pick an account.');
        return;
      }

      this.loading = true;
      this.statement_unavailable = false;

      /**
       * getForCheckout asks for the json_statement - the statement the horse show
       * office synchronized up to us, with any payments and refunds made on-line
       * since that sync merged in. The account list this page is opened from is
       * built from the same synchronized figures, so the two agree. The plain
       * statement flag builds a statement from the on-line ledger instead, which
       * is a different set of books and would not match the list.
       */
      this.horseShowEntryService.getForCheckout(entry_id, true, false, false).then(entry => {

        this.entry = entry;

        if(!entry.statement){
          this.statement_unavailable = true;
          this.entry.statement = this.getBlankHorseShowEntry().statement;
        }

        return this.horseShowService.get(entry.horse_show_id).then(horse_show => {
          this.horse_show = horse_show;
          return Promise.all([
            this.organizerService.get(horse_show.competition_organizer_id).then(organizer => { this.organizer = organizer; }),
            this.venueService.get(horse_show.venue_id).then(venue => { this.venue = venue; })
          ]);
        });

      }).then(() => {
        this.loading = false;
      }).catch(error => {
        this.handleError(error);
        this.loading = false;
      });

    });

  }

  private getBlankHorseShowEntry(): Horse_show_entry {
    return new Horse_show_entry({horse:{},
      owner:{},
      trainer:{},
      payee:null,
      statement:{
        section_entry_fees:[],
        competition_entry_fees:[],
        summary_bill_items: [],
        transfers_out: [],
        transfers_in: [],
        tax_items: [],
        payments: [],
        prize_monies: [],
        refunds: []
      }});
  }

}
